import { SET_TOAST } from '../store/types/toast.type'

export const returnError = (err) => {
  return { error: { message: err } }
}

export const notifyToast = (status, message) => (dispatch) => {
  dispatch({
    type: SET_TOAST,
    payload: {
      status,
      message: message || 'Unexpected Error, please try again later!',
    },
  })
}
